import { PORTRAIT_URL, CREDIBILITY, MERILYN_BIO, MERILYN_QUOTE } from "@/lib/content";
import Reveal from "@/components/landing/Reveal";

export default function Merilyn() {
    return (
        <section
            id="founder"
            data-testid="merilyn-section"
            className="bg-pearl-soft py-32 md:py-44 relative overflow-hidden"
        >
            <div className="max-w-[1300px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-start">
                {/* portrait — sticks while you read the bio */}
                <Reveal className="lg:col-span-5 lg:col-start-1 lg:sticky lg:top-28">
                    <div className="relative">
                        <div className="aspect-[4/5] w-full overflow-hidden">
                            <img
                                src={PORTRAIT_URL}
                                alt="Merilyn Smith, founder of Arc & Light"
                                className="w-full h-full object-cover"
                                data-testid="merilyn-portrait"
                            />
                        </div>
                    </div>
                </Reveal>

                {/* copy */}
                <div className="lg:col-span-7 lg:pl-8">
                    <Reveal>
                        <p className="eyebrow text-cacao/60 mb-8">
                            <span className="divider-line text-cacao/40 mr-4 align-middle" />
                            The Founder
                        </p>
                    </Reveal>
                    <Reveal delay={120}>
                        <h2
                            data-testid="merilyn-headline"
                            className="font-serif text-cacao text-[2.2rem] sm:text-[2.8rem] md:text-[3.6rem] leading-[1.05] max-w-[18ch]"
                        >
                            {"An artist\u2019s eye."}
                            <span className="block italic text-clay-deep">{"An architect\u2019s discipline."}</span>
                        </h2>
                    </Reveal>

                    <div className="mt-10 space-y-6 max-w-[36rem]" data-testid="merilyn-bio">
                        {MERILYN_BIO.map((para, i) => (
                            <Reveal
                                as="p"
                                key={i}
                                delay={120 + i * 80}
                                className="text-cacao/80 text-[1rem] md:text-[1.05rem] leading-[1.85] font-light"
                            >
                                {para}
                            </Reveal>
                        ))}
                    </div>

                    <Reveal delay={500}>
                        <blockquote
                            data-testid="merilyn-quote"
                            className="mt-14 border-l-2 border-clay pl-6 md:pl-8 max-w-[36rem]"
                        >
                            <p className="font-script text-clay-deep text-[1.85rem] md:text-[2.4rem] leading-[1.18]">
                                {MERILYN_QUOTE}
                            </p>
                        </blockquote>
                    </Reveal>

                    <Reveal delay={640}>
                        <ul
                            data-testid="merilyn-credibility"
                            className="mt-12 flex flex-wrap gap-x-8 gap-y-3"
                        >
                            {CREDIBILITY.map((c) => (
                                <li
                                    key={c}
                                    className="text-cacao/70 text-[0.7rem] tracking-[0.28em] uppercase"
                                >
                                    {c}
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
